import React from "react"
import SEO from "../../components/seo"
import HeroFeaturePage from "../../components/pages/shared/hero/feature-page"
import Layout from "../../components/layout"
import AboutComponent from "../../components/pages/main/about"
import FeaturesComponent from "../../components/pages/main/landing-features"
import ContactFormComponent from "../../components/pages/shared/contact-form"
import FeatureAccordion from "../../components/pages/main/accordion"
import BannerComponent from "../../components/pages/features/banner"
import FeaturesRow from "../../components/pages/features/row"
import Discount from "../../components/pages/main/discount"
import Breadcrumb from '../../components/controls/breadcrumbs';

const wagesAccordionData = [
  {
    name: "withoutMistakes",
    title: "Как расчет зарплаты сотрудников через CRM позволяет избежать ошибок?",
    content: `
      <p>В CRM-системе есть готовые функциональности для создания гибкой зарплатной ставки педагога в зависимости от различных показателей. Вы можете выбрать только оклад или начисление заработной платы сотруднику за количество отведенных часов, за количество учеников, присутствующих на занятии, фиксированную или процентную ставку за занятие. Такой подход исключает ошибки в расчете зарплаты, избавляет от рутины в ежедневных процессах, исключает ручной ввод данных для руководителя, бухгалтера и кадровика. Главное, программа для расчета зарплаты экономит ваше время от долгих перепроверок корректности данных. Сотрудники смогут убедиться, что зарплата рассчитана корректно. В Параплан CRM можно посмотреть детализацию начислений педагогу, историю выплат, выгрузить информацию в формате PDF, начислить бонусы и штрафы. Экономия времени и прозрачных расчет любых выплат через CRM-систему Параплан.</p>
    `,
  },
  {
    name: "correct",
    title: "Как сотрудник детского центра может убедиться в корректности выплаты зарплаты?",
    content: `
      <p>При использовании программы для расчета зарплаты вы сможете продемонстрировать вашей команде честность и открытость в подходе к начислению зарплаты. Благодаря прозрачности системы расчета заработной платы у сотрудников вашего центра не будет возникать недопонимание и недовольство. Любой сотрудник сможет убедиться в корректности цифр, получив отчет, где будет наглядно видно, по какому алгоритму, за какой период и какая сумма начислений ему полагается. Также педагог или любой другой сотрудник может посмотреть историю выплат и схему расчета в своем профиле.</p>
    `,
  }
]

const WagesFeaturePage = (props) => {
  const crumbs = [
    { name: 'Главная', url: '/'},
    { name: 'Возможности', url: '/feature'},
    { name: 'Расчет зарплат', url: ''}
  ];
  return (
    <Layout headerColor={"#F2A819"} page={"wages"}>
      <SEO
        title="Программа расчета зарплаты сотрудникам"
        description="Программа расчета зарплат в CRM-системе Параплан проведет автоматический расчет выплат сотрудникам по окладу или трем видам зарплатных ставок."
        url={"https://paraplancrm.ru" + props.location.pathname}
      />
      <HeroFeaturePage
        name={"wages"}
        title='Автоматизируйте расчет зарплат'
        description='Выберите период оплаты и система сделает полный расчет зарплаты сотрудника за вас.'
        color='#F2A819'
        btnDark={true}
        image={require("../../images/cover/wages.png")}/>
      <Breadcrumb crumbs={ crumbs } arrowcolor={"yellow"}/>
      <AboutComponent
        title='Расчет зарплаты<br/> без бухгалтера'
        description='Ручной подсчет зарплаты и учет выплат займет много времени. Специалист может ошибиться, информация может потеряться, а подсчет оказаться не точным. Программа расчета зарплаты Параплан CRM поможет вам провести автоматические выплаты онлайн и сохранить историю операций за каждым сотрудником.'
        image={require("../../images/screenshot/wages/wages-1.png")}
        imageWidth={607}
        imageHeight={370}
        reverse={true}
        color='#03C4A4'/>
      {/*<FreeSummer topInd="100"/>*/}
      <Discount />
      <AboutComponent
        title='Зарплатная схема устанавливается так, <br/> как работаете вы:'
        image={require("../../images/screenshot/wages/wages_02@2x.png")}
        bgSize={"big-image"}
        bullets={[
          "Оклад",
          "Ставка за групповое и индивидуальное занятие",
          "Почасовая оплата",
          "Ставка в зависимости от количества учеников",
          "Процентная схема от продажи абонементов",
          "Гибкие индивидуальные настройки",
        ]}
        imageWidth={671}
        imageHeight={465}
        color='#E65D49'/>
      <FeaturesRow
        features={[
          {
            name: "Автоматический расчет",
            text: "Программа автоматически начислит преподавателю заработную плату после проведенного занятия.",
            image: require("../../images/icons/wages_calculate.svg"),
          },
          {
            name: "Зарплатная ведомость",
            text: "В конце расчетного периода программа сформирует зарплатную ведомость по проведенным неоплаченным занятиям.",
            image: require("../../images/icons/wages_receipt.svg"),
          },
          {
            name: "Редактирование ведомости",
            text: "Пользователь сможет отредактировать ведомость или добавить дополнительные выплаты по необходимости.",
            image: require("../../images/icons/wages_editor.svg"),
          },
        ]}/>
      <BannerComponent author={"Елена Бус, курсы английского языка в Самаре"}>
        Вести учет и контролировать посещаемость теперь не только удобно, но и приятно. В системе понятный и
        user-friendly интерфейс, а если есть вопросы, то всегда поможет менеджер.
      </BannerComponent>
      <FeaturesComponent title="Дополнительные возможности"/>
      <ContactFormComponent/>
      <FeatureAccordion
            data={wagesAccordionData}
            title='Как упростить расчет зарплаты сотрудников через программу'
            descr='Задумывались ли вы над тем, сколько времени тратится на ручной расчет заработной платы сотрудников детского центра? Особенно, если выплата зарплаты происходит каждую неделю. Этот процесс может “съедать” драгоценное время, которое вы могли бы потратить на стратегические задачи по развитию бизнеса. Мы предлагаем вам оптимальное решение. В CRM-системе для детских и учебных центров Параплан есть возможность автоматически рассчитывать заработную плату педагогов и администраторов. Руководителю центра не нужно вручную осуществлять сверку расписания занятий, вести учет посещений учеников, уточнять ставку преподавателей и так далее. CRM с возможностью расчета зарплаты сотрудников онлайн сделает все за вас. Владельцу бизнеса необходимо только единожды настроить одну из трех доступных зарплатных ставок, а далее CRM-система рассчитает зарплату, исходя из проведенных занятий, и сформирует зарплатную ведомость в фоновом режиме. Все действия будут сохранены в системе, вы в любой момент сможете скачать информацию о выплатах или предоставить отчет сотруднику. Переложите на CRM-систему Параплан еще больше рутинных задач.
            '
      />
    </Layout>
  )
}

export default WagesFeaturePage
